export function getdata() {
	var obj = {
		headData: [{
				title: "系统命名",
				prop: "test1",
				width: "200px"
			},
			{
				title: "字段类型",
				prop: "test2",
				custom: true,
				width: "200px"
			},
			{
				title: "展示命名",
				prop: "test3",
				custom: true,
				width: "200px"
			},

		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		}
	}
	return obj
}
